import { render } from "./SocialInstagram.vue?vue&type=template&id=5196c097"
import script from "./SocialInstagram.vue?vue&type=script&lang=js"
export * from "./SocialInstagram.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__